import { inject, Injectable } from '@angular/core';
import { v4 as uuidv4 } from 'uuid';
import { map, Observable } from 'rxjs';
import { environment } from 'src/environments/environment';
import { CommonClientService } from '../common-client-service.service';

export interface MsalAuthResult {
  readonly code: string;
  readonly email: string;
}

export interface MsalAuthError {
  readonly errorCode: string;
  readonly description: string;
  readonly needsAdminConsent: boolean;
}

@Injectable({
  providedIn: 'root',
})
export class MsalClientService {
  private readonly _commonClient = inject(CommonClientService);

  popUpMicrosoftLoginToRetrieveAuthCode(): Observable<MsalAuthResult> {
    const state = uuidv4();

    const scopes = [
      'openid',
      'email',
      'profile',
      'https://service.flow.microsoft.com//Flows.Read.All',
      'https://service.flow.microsoft.com//User',
      'https://service.powerapps.com//User',
      'https://graph.microsoft.com//User.Read.All',
      'offline_access',
    ];

    const url = new URL('https://login.microsoftonline.com' + '/common/oauth2/v2.0/authorize');

    url.searchParams.append('client_id', environment.msal.oauthClientId);
    url.searchParams.append('redirect_uri', environment.zenityRedirectUriForOauthAuthorizationCodeFlow);
    url.searchParams.append('state', state);
    url.searchParams.append('scope', scopes.join(' '));
    url.searchParams.append('response_type', 'code');

    return this._commonClient
      .openPopupToRetrieveAuthCode('Microsoft', url, state)
      .pipe(map((code) => ({ code, email: '' })));
  }
}
